<template>
  <div class="modal productItemModal" id="productItemModal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{Product.Name}}</h5>
          <span>${{totalPrice}}</span>
        </div>
        <div class="modal-body">
          <div v-for="(productLabel, index) in Product.productLabels" :key="productLabel">
            <div v-if="index > 0"><hr></div>
            <div class="productLabelName">
              <span>✽ {{productLabel.Name}}</span>
            </div>
            <div class="flex_container">
              <div class="productItems btn btn-lg" 
                :class="{ 'noSalesStatus': productItem.salesStatus == 0, 'btn-outline-dark': !productItem.Clicked, 'btn-dark': productItem.Clicked }" 
                v-for="productItem in productLabel.productItems" :key="productItem" 
                @click="addProductItem(productLabel, productItem)"
              >
                <div class="flex_box">
                  {{productItem.Name}}
                  <div v-if="productItem.Price">
                    <span v-if="productItem.Price > 0">+</span><span v-else>-</span>{{productItem.Price}}元
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="FooterTop">
            <div class="TopLeft">
              <span class="noProductTip">（若出現紅字表示售完）</span>
            </div>
            <div class="TopRight">
              <div class="productBuy">
                <button class="btn btn-sm" @click.stop="editCount(-1)">−</button>
                <span class="Count">{{ Count }}</span>
                <button class="btn btn-sm" @click.stop="editCount(1)">+</button>
              </div>
            </div>
          </div>
          <div class="FooterBottom">
            <div class="BottomLeft">
              <button class="btn btn-secondary" @click="closeProductItemModal(Product)">關閉此視窗</button>
            </div>
            <div class="BottomRight">
              <button class="btn btn-primary" @click="addProduct(Product)">加入購物車</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Global } from '@/Service/GlobalService'
import { swal } from '@/Service/SweetAlert2'
export default {
  name: "ProductItem",
  data() {
    return {
      Price: null,  // 商品預設價格
      Count: 1,     // 選取的商品數量
    }
  },
  props: {
    Product: Object,          // 商品資料
    productCategory: Object,  // 商品類別資料
  },
  watch: {
    /*
     * deep: true 會監聽 productLabels / productItems 的巢狀變動。
     * 選口味時會改 item.Clicked，且 Products 開 modal 只做淺拷貝（{ ...Product }），
     * 巢狀物件與 productsData 共用參考 → Clicked 一變就會觸發本 watcher。
     * 若無 id 判斷，每次選細項都會把 Price 重設回商品原價，加價選項（如花生 +15）就加不上。
     * 因此只在「換成另一個商品」時初始化 Price / Count。
     */
    Product: {
      handler(newVal, oldVal) {
        if (!newVal) return
        if (oldVal && newVal.id === oldVal.id) return
        if (newVal.Price !== undefined) this.Price = Number(newVal.Price)
        this.Count = 1
      },
      deep: true,
      immediate: true,
    },
    Count: {
      handler(newVal) {
        if (newVal < 1) this.Count = 1
        if (newVal > 99) this.Count = 99
      }
    }
  },
  computed: {
    totalPrice() {
      return Number(this.Price) * Number(this.Count)
    }
  },
  methods: {
    /* 使用者點擊後，增加的商品細項 */
    addProductItem(productLabel, productItem) {
      const categories = this.$parent.$parent.$data.productsData

      // 找到目前 Product
      const currentProduct = categories
        .flatMap(c => c.Products)
        .find(p => p.id == this.$props.Product.id)
      if (!currentProduct) return

      // 找到指定 Label
      const targetLabel = currentProduct.productLabels
        .find(l => l.id == productLabel.id)
      if (!targetLabel) return

      // 同一個 label 只能選一個 item（維持原邏輯）
      for (const item of targetLabel.productItems) {
        const isTargetItem = (item.id == productItem.id)

        if (isTargetItem) {
          if (productItem.salesStatus == 1) {
            if (!item.Clicked) this.$data.Price += Number(item.Price) || 0
            item.Clicked = true
          }
          else {
            swal.alertError("這個細項已經售完！")
            return
          }
          continue
        }

        // 非目標 item：全部取消（維持原邏輯）
        if (item.Clicked) this.$data.Price -= Number(item.Price) || 0
        item.Clicked = false
      }
    },
    /* 檢查是否所有商品的標籤都至少選擇一個細項 */
    checkProducthasAllItems: function() {
      let Flag = false
      for (const productCategoryKey of this.$parent.$parent.$data.productsData) {
        for (const productKey of productCategoryKey.Products) {
          if (productKey.id == this.$props.Product.id) {
            for (const productLabelKey of productKey.productLabels) {
              let itemFlag = false
              for (const productItemKey of productLabelKey.productItems) {
                if (productItemKey.Clicked) itemFlag = true
              }
              if (!itemFlag) Flag = true
            }
          }
        }
      }
      if (Flag) {
        swal.alertError("所有標籤都至少要選擇一個細項！")
        return false
      }
      return true
    },
    /* 商品數量調整 */
    editCount: function(i) {
      this.$data.Count += i
      if (this.$data.Count == null || this.$data.Count < 1) {
        this.$data.Count = 1
      } else if (this.$data.Count > 99) {
        this.$data.Count = 99
      }
    },
    /* 商品數量自動調整 */
    blurNumber: function() {
      if (this.$data.Count == null || this.$data.Count == 0) {
        this.$data.Count = 1
      } else if (this.$data.Count > 99) {
        this.$data.Count = 99
      }
    },
    /* 確認商品數量 */ 
    checkCount: function() {
      if (this.$data.Count == null || this.$data.Count == 0) {
        swal.alertError("商品數量不可為零！")
        return false
      } else if (this.$data.Count > 99) {
        swal.alertError("商品數量不可為零！")
        return false
      }
      return true
    },
    /* 使用者點擊新增後，增加至購物車內 */
    addProduct: function (Product) {
      if (!this.checkProducthasAllItems(Product)) return false
      if (!this.checkCount()) return false

      const cart = this.$parent.$parent.Cart[0].Data

      const newItems = Product.productLabels.flatMap(label => {
        return label.productItems
          .filter(item => item.Clicked)
          .map(item => ({
            itemId: item.id,
            labelId: label.id,
            Name: item.Name,
            Price: item.Price
          }))
      })

      // 🔑 找購物車中是否已有相同商品（含規格）
      const existOrder = cart.find(order => {
        if (
          order.productId !== Product.id ||
          order.productCategoryId !== this.$props.productCategory.id
        ) return false

        if (order.Items.length !== newItems.length) return false

        // 比較 Items（忽略順序）
        return order.Items.every(oItem =>
          newItems.some(nItem =>
            nItem.itemId === oItem.itemId &&
            nItem.labelId === oItem.labelId
          )
        )
      })

      if (existOrder) {
        // ✅ 已存在 → 數量 +1
        existOrder.Count += this.$data.Count
      } else {
        // ❌ 不存在 → 新增一筆
        cart.push({
          productCategoryId: this.$props.productCategory.id,
          productId: Product.id,
          Name: Product.Name,
          Price: this.$data.Price,
          Image: Product.Image,
          Count: this.$data.Count,
          Items: newItems
        })
      }

      localStorage.setItem(
        'Cart.' + Global.Shop.id,
        JSON.stringify(cart)
      )

      this.closeProductItemModal(Product)
    },
    /* 關閉商品細項視窗 */
    closeProductItemModal: function(Product) {
      for (const productCategoryKey of this.$parent.$parent.$data.productsData) {
        for (const productKey of productCategoryKey.Products) {
          if (productKey.id == Product.id) {
            for (const productLabelKey of productKey.productLabels) {
              for (const productItemKey of productLabelKey.productItems) {
                if (productItemKey.Clicked) this.$data.Price -= Number(productItemKey.Price) || 0
                productItemKey.Clicked = false
              }
            }
          }
        }
      }
      this.$data.Count = 1
      $("#productItemModal").modal('hide')
    },
  },
  beforeUnmount() {
    $("#productItemModal").modal('hide')
  },
}
</script>

<style lang="scss" scoped>
.productItemModal {
  > .modal-dialog {
    > .modal-content {
      > .modal-header {
        > .modal-title {
          font-weight: bold;
        }
      }
      > .modal-body {
        .productLabelName {
          display: flex;
          justify-content: space-between;
          margin-bottom: 14px;
          font-weight: bold;
          color: #0d6efd;
        }
        .flex_container {
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          > .productItems {
            display: flex;
            align-items: center; 
            margin-right: 14px;
            margin-bottom: 14px;
            > .flex_box {
              min-width: 60px;
              font-size: 14px;
            }
          }
          > .noSalesStatus {
            border: 1px solid red;
            color: red;
          }
        }
      }
      .modal-footer {
        display: flex;
        flex-direction: column;
        gap: 0px;
        padding: 12px 16px;
        overflow: visible; 

        /* =========================
          上排（桌機 / 手機共用）
          ========================= */
        .FooterTop {
          display: grid;
          // grid-template-columns: 2fr 1fr; // 手機左寬右窄也適用
          grid-template-columns: minmax(0, 1fr) auto;
          align-items: center;
          min-height: 48px;
          width: 100%;
        }

        .TopLeft {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          font-size: 0;
          min-width: 0;
          height: 100%;

          .noProductTip {
            color: red;
            font-weight: bold;
            font-size: 16px;
            line-height: 1;
          }
        }

        .TopRight {
          display: flex;
          align-items: center;
          justify-content: flex-end;

          .productBuy {
            display: flex;
            align-items: center;

            > button {
              width: 32px;
              height: 32px;
              border-radius: 50%;
              background-color: #5599FF;
              color: #fff;
              padding: 0;
            }

            > button:first-child {
              margin-right: 12px;
            }

            > button:last-child {
              margin-left: 12px;
            }

            .Count {
              font-size: 18px;
              font-weight: bold;
              margin: 0 4px;
            }
          }
        }

        /* =========================
          下排（桌機：左右靠邊）
          ========================= */
        .FooterBottom {
          display: grid;
          grid-template-columns: 1fr 1fr;
          padding-top: 10px;
          padding-bottom: 5px;
          gap: 12px;
          width: 100%;
        }

        .BottomLeft {
          display: flex;
          justify-content: flex-start;

          .btn {
            font-size: 16px;
            font-weight: bold;
            color: #fff;
          }
        }

        .BottomRight {
          display: flex;
          justify-content: flex-end;

          .btn {
            font-size: 16px;
            font-weight: bold;
            color: #fff;
          }
        }

        /* =========================
          📱 手機版專屬行為
          ========================= */
        @media (max-width: 576px) {
          /* 下排按鈕要全寬 */
          .BottomLeft,
          .BottomRight {
            justify-content: center;
            .btn {
              width: 100%;
              height: 44px;
            }
          }

        }
      }
    }
  }
}
</style>